import React from "react";
import { ArrowBackCircle, ArrowForwardCircle, ArrowDownCircle, ListOutline, CalendarOutline } from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import { Modal } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import constantURI from "../URI"
import _post from "../Functions/Post"
import stylesMed from "./stylesMed"
import Calendar from "./Calendar"
import Authenticate from "../Functions/MedRepAuthenticate"

export default class Plan extends React.Component {

    constructor() {
        super();
        this.state = {
            temp: [],
            temp2: [],
            visits: [],
            visitsCopy: [],
            noData: true,
            showDetail: [],
            showAlert: false,
            Date: new Date(),
            User: "",
            Reps: [],
            isRep: false,
            selectedRep: "",
            disableApprove: false,
            loading: true,
            HCPs: [],
            checked: [],
            token: "",
            isSupervisor: false,
            isPlan: true,
            fromDate: new Date(),
            toDate: new Date(),
            fromDatePlan: new Date(),
            toDatePlan: new Date(),
            previousVisits: [],
            previousVisitsCopy: [],
            previousVisitsBody: {},
            checkedVisits: [],
            status: [],
            showDecline: false,
            showDeclineONE: [],
            reason: "Cancelled by supervisor: Declined by bulk from supervisor",
            reasonOne: "Cancelled by supervisor: ",
            fetchVisitsBody: {},
            currentUser: "",
            selectAll: false,
            isList: true,
            isCancelled: false,
            isDaily: true,
            isWeekly: false,
            authenticate: false,
            alertUndefined: false
        }
    }

    async componentDidMount() {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        const user = localStorage.getItem("User");
        const HCPs = localStorage.getItem("HCPs");
        const token = localStorage.getItem("Token");
        var isSupervisor = localStorage.getItem("isSupervisor");
        await this.setState({ User: JSON.parse(user), HCPs: JSON.parse(HCPs), token: JSON.parse(token), isSupervisor: JSON.parse(isSupervisor) });

        const plannedVisitsURL = constantURI() + "odooController/MedRepRead";
        if (this.state.isSupervisor) {
            await this.setState({ isRep: true });
            this.fetchVisits(this.state.User);
        }
        else {
            await this.setState({ isRep: false, loading: false });
            const RepsBody = {
                "jsonrpc": "2.0",
                "params": {
                    "method": "search_read",
                    "model": "res.users",
                    "args": [],
                    "kwargs": {
                        "fields": ["name", "supervisor"],
                        "domain": [["supervisor", "=", this.state.User]]
                    }
                },
                "token": this.state.token
            }
            if (this.state.authenticate) {
                await _post(plannedVisitsURL, RepsBody).then((response) => {
                    return response.json().then((data) => {
                        if (data.result !== undefined) {
                            this.setState({ Reps: data.result });
                            localStorage.setItem('Reps', JSON.stringify(this.state.Reps));
                        } else {
                            this.setState({ alertUndefined: true });
                        }

                    })
                })
            }
            else {
                const reps = localStorage.getItem('Reps');
                this.setState({ Reps: JSON.parse(reps) });
            }
        }
    }

    groupArrayOfObjects(list, key) {
        return list.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }

    onShowDetails = (index) => {
        this.setState({ ...this.state.showDetail[index] = !this.state.showDetail[index] });
    }

    closeAlert = () => {
        this.setState({ showAlert: false });
    }

    showAlert = () => {
        this.setState({ showAlert: true });
    }

    fetchVisits = async (rep) => {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        this.setState({ loading: true });
        const plannedVisitsURL = constantURI() + "odooController/MedRepRead";
        //const plannedVisitsBody = {
        //    jsonrpc: "2.0",
        //    params: {
        //        method: "search_read",
        //        model: "calendar.event",
        //        args: [],
        //        kwargs: {
        //            fields: ["name", "x_status", "start_datetime", "start_date", "partner_ids"],
        //            domain: [["x_status", ">", "2"], ["x_status", "<", "5"], ["partner_ids", "=", rep]],
        //            order: "start_date DESC"
        //        }
        //    },
        //    "token": this.state.token
        //}
        const plannedVisitsBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "calendar.event",
                args: [],
                kwargs: {
                    fields: ["name", "x_status", "start_datetime", "start_date", "partner_ids"],
                    domain: [["x_status", "=", "0"], ["partner_ids", "=", rep]],
                    order: "id DESC"
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(plannedVisitsURL, plannedVisitsBody).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        this.setState({ temp: data.result })
                        const groups = this.groupArrayOfObjects(this.state.temp, 'start_date');
                        this.setState({ visits: groups, visitsCopy: groups, loading: false });
                        localStorage.setItem('PlannedVisits', JSON.stringify(this.state.visits));
                        if (Object.keys(this.state.visits).length !== 0) {
                            const maxDate = new Date(Object.keys(this.state.visits)[0]);
                            if (maxDate <= this.state.Date) {
                                await this.setState({ Date: new Date() });
                            } else {
                                await maxDate.setDate(maxDate.getDate() + 1);
                                await this.setState({ Date: maxDate });
                            }
                        }
                    } else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const visits = localStorage.getItem('PlannedVisits');
            this.setState({ visits: JSON.parse(visits), visitsCopy: JSON.parse(visits), loading: false });
        }
    }

    fetchVisitsDate = async () => {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        this.setState({ loading: true });
        if (this.state.isSupervisor)
            this.state.currentUser = this.state.User;
        else
            this.state.currentUser = this.state.selectedRep;
        const plannedVisitsURL = constantURI() + "odooController/MedRepRead";
        if (this.state.fromDatePlan.toISOString().substring(0, 10) === this.state.toDatePlan.toISOString().substring(0, 10)) {
            {
                await this.setState({
                    fetchVisitsBody: {
                        "jsonrpc": "2.0",
                        "params": {
                            "method": "search_read",
                            "model": "calendar.event",
                            "args": [],
                            "kwargs": {
                                "fields": ["partner_ids", "start_datetime", "name", "x_status", "start_date"],
                                "domain": [["x_status", "=", "0"], ["partner_ids", "=", this.state.currentUser], ["start_date", "=", this.state.fromDatePlan.toISOString().substring(0, 10)]],
                                "order": "start_date DESC"

                            }
                        },
                        "token": this.state.token
                    }
                })
            }
        }
        else {
            await this.setState({
                fetchVisitsBody: {
                    "jsonrpc": "2.0",
                    "params": {
                        "method": "search_read",
                        "model": "calendar.event",
                        "args": [],
                        "kwargs": {
                            "fields": ["partner_ids", "start_datetime", "name", "x_status", "start_date"],
                            "domain": [["start_date", ">=", this.state.fromDatePlan.toISOString().substring(0, 10)], ["start_date", "<=", this.state.toDatePlan.toISOString().substring(0, 10)], ["x_status", "=", "0"], ["partner_ids", "=", this.state.currentUser]],
                            "order": "start_date DESC"

                        }
                    },
                    "token": this.state.token
                }
            })
        }
        if (this.state.authenticate) {
            await _post(plannedVisitsURL, this.state.fetchVisitsBody).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        this.setState({ temp: data.result })
                        const groups = this.groupArrayOfObjects(this.state.temp, 'start_date');
                        this.setState({ visits: groups, visitsCopy: groups, loading: false });
                        localStorage.setItem('PlannedVisits', JSON.stringify(this.state.visits));
                    } else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const visits = localStorage.getItem('PlannedVisits');
            this.setState({ visits: JSON.parse(visits), visitsCopy: JSON.parse(visits), loading: false });
        }
    }

    fetchPreviousVisits = async () => {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        this.setState({ loading: true });
        const plannedVisitsURL = constantURI() + "odooController/MedRepRead";
        if (this.state.fromDate.toISOString().substring(0, 10) === this.state.toDate.toISOString().substring(0, 10)) {
            {
                await this.setState({
                    previousVisitsBody: {
                        "jsonrpc": "2.0",
                        "params": {
                            "method": "search_read",
                            "model": "calendar.event",
                            "args": [],
                            "kwargs": {
                                "fields": ["partner_ids", "start_datetime", "name", "x_status", "start_date", "x_purpose", "x_fbgeneral"],
                                "domain": [["partner_ids", "=", (!this.state.isRep) ? this.state.selectedRep : this.state.User], ["start_date", "=", this.state.fromDate.toISOString().substring(0, 10)],
                                ["x_status", "<", "3"]
                                ],
                                "order": "start_date DESC"

                            }
                        },
                        "token": this.state.token
                    }
                })
            }
        }
        else {
            await this.setState({
                previousVisitsBody: {
                    "jsonrpc": "2.0",
                    "params": {
                        "method": "search_read",
                        "model": "calendar.event",
                        "args": [],
                        "kwargs": {
                            "fields": ["partner_ids", "start_datetime", "name", "x_status", "start_date", "x_purpose", "x_fbgeneral"],
                            "domain": [["partner_ids", "=", (!this.state.isRep) ? this.state.selectedRep : this.state.User], ["start_date", ">=", this.state.fromDate.toISOString().substring(0, 10)],
                            ["start_date", "<=", this.state.toDate.toISOString().substring(0, 10)], ["x_status", "<", "3"]],
                            "order": "start_date DESC"

                        }
                    },
                    "token": this.state.token
                }
            })
        }
        if (this.state.authenticate) {
            await _post(plannedVisitsURL, this.state.previousVisitsBody).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        this.setState({ temp2: data.result })
                        const groups = this.groupArrayOfObjects(this.state.temp2, 'start_date');
                        await Object.keys(groups).sort(function compare(a, b) {
                            var dateA = new Date(a.date);
                            var dateB = new Date(b.date);
                            return dateB - dateA;
                        });
                        await this.setState({ previousVisits: groups, previousVisitsCopy: groups, loading: false });
                        localStorage.setItem('PreviousVisits', JSON.stringify(this.state.previousVisits));
                    } else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const visits = localStorage.getItem('PreviousVisits');
            this.setState({ previousVisits: JSON.parse(visits), previousVisitsCopy: JSON.parse(visits), loading: false });
        }
    }

    onChangeSelectedRep = async (e) => {
        await this.setState({ selectedRep: e.target.value, loading: true });
        localStorage.setItem("SelectedRep", JSON.stringify(this.state.selectedRep));
        await this.fetchVisits(this.state.selectedRep);
    }

    onApprove = async (id, status) => {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        await this.setState({ disableApprove: true });
        const updateVisitURL = constantURI() + "odooController/UpdateVisit";
        if (status !== "3") {
            var visitUpdateBody = {
                jsonrpc: "2.0",
                params: {
                    method: "write",
                    model: "calendar.event",
                    args: [[id], {
                        "x_status": "0",
                    }
                    ],
                    "kwargs": {}
                },
                "token": this.state.token
            }
            if (this.state.authenticate) {
                await _post(updateVisitURL, visitUpdateBody).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                            await this.fetchVisits(this.state.selectedRep).then(() => {
                                this.setState({ disableApprove: false })
                            })
                        } else {
                            this.setState({ alertUndefined: true });
                        }
                    })
                })
            }
            else {
                alert("Please connect to the Internet!");
            }
        }
        else {
            var visitUpdateBody = {
                jsonrpc: "2.0",
                params: {
                    method: "write",
                    model: "calendar.event",
                    args: [[id], {
                        "x_status": "2",
                    }
                    ],
                    "kwargs": {}
                },
                "token": this.state.token
            }
            if (this.state.authenticate) {
                await _post(updateVisitURL, visitUpdateBody).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                            await this.fetchVisits(this.state.selectedRep).then(() => {
                                this.setState({ disableApprove: false })
                            })
                        } else {
                            this.setState({ alertUndefined: true });
                        }
                    })
                })
            }
            else {
                alert("Please connect to the Internet!");
            }
        }
    }

    onSave = async () => {
        await this.setState({ isCancelled: false });
        const temp = [];
        const d = new Date();
        d.setDate(d.getDate());
        if (this.state.Date.toISOString().substring(0, 10) < d.toISOString().substring(0, 10)) {
            alert("Can not schedule before today's date: " + d.toISOString().substring(0, 10))
        }
        else {
            localStorage.setItem("Daily", JSON.stringify(this.state.isDaily));
            localStorage.setItem("Weekly", JSON.stringify(this.state.isWeekly));

            await Object.entries(this.state.visits).map((key, value) => {
                if (key[0] === this.state.Date.toISOString().substring(0, 10)) {
                    key[1].map((item, index) => {
                        if (item.x_status === "3") {
                            alert("This route is cancelled.");
                            this.setState({ showAlert: false, isCancelled: true });
                        }
                        else {
                            temp.push(item.partner_ids[0]);
                        }
                    })
                }
            })
            if (temp.length !== 0) {
                await this.state.HCPs.forEach((client) => {
                    temp.forEach((item) => {
                        if (item === client.id) {
                            this.setState({ ...this.state.checked[client.id] = true });
                        }
                    })
                })
                this.setState({ showAlert: false });
                localStorage.setItem('CheckedDoctors', JSON.stringify(this.state.checked));
                localStorage.setItem('RouteDate', JSON.stringify(this.state.Date.toDateString()));
                localStorage.setItem('RouteDate2', JSON.stringify(this.state.Date.toISOString().substring(0, 10)));
                this.props.history.push("./AddRoute")
            }
            else if (temp.length === 0 && !this.state.isCancelled) {
                this.setState({ showAlert: false });
                localStorage.setItem('CheckedDoctors', JSON.stringify(this.state.checked));
                localStorage.setItem('RouteDate', JSON.stringify(this.state.Date.toDateString()));
                localStorage.setItem('RouteDate2', JSON.stringify(this.state.Date.toISOString().substring(0, 10)));
                this.props.history.push("./AddRoute")
            }
        }
    }

    onTabPress = (isPlan) => {
        this.setState({ isPlan: isPlan });
    }

    onDeclineONE = async (id) => {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        await this.setState({ disableApprove: true });
        const updateVisitURL = constantURI() + "odooController/UpdateVisit";
        var visitUpdateBody = {
            jsonrpc: "2.0",
            params: {
                method: "write",
                model: "calendar.event",
                args: [[id], {
                    "x_status": "9",
                    "x_cancelreason": this.state.reasonOne
                }
                ],
                "kwargs": {}
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(updateVisitURL, visitUpdateBody).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        await this.fetchVisits(this.state.selectedRep).then(() => {
                            this.setState({ disableApprove: false })
                        })
                    } else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            this.setState({ reasonOne: "Cancelled by supervisor: " });
        }
        else {
            alert("Please connect to the Internet!");
        }
    }

    onDecline = async () => {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        await this.setState({ disableApprove: true });
        const updateVisitURL = constantURI() + "odooController/UpdateVisit";
        this.state.checkedVisits.map(async (item, index) => {
            if (item == true) {
                var visitUpdateBody = {
                    jsonrpc: "2.0",
                    params: {
                        method: "write",
                        model: "calendar.event",
                        args: [[index], {
                            "x_status": "9",
                            "x_cancelreason": this.state.reason
                        }
                        ],
                        "kwargs": {}
                    },
                    "token": this.state.token
                }
                if (this.state.authenticate) {
                    await _post(updateVisitURL, visitUpdateBody).then((response) => {
                        return response.json().then(async (data) => {
                            if (data.result !== undefined) {
                                await this.fetchVisits(this.state.selectedRep).then(() => {
                                    this.setState({ disableApprove: false })
                                })
                                this.closeDecline();
                            } else {
                                this.setState({ alertUndefined: true });
                            }
                        })
                    })
                }
                else {
                    alert("Please connect to the Internet!");
                }
            }
        })
    }

    onCheck = (newValue, index, status) => {
        this.setState({ ...this.state.checkedVisits[index] = newValue.nativeEvent.target.checked });
        this.setState({ ...this.state.status[index] = status });
        localStorage.setItem('CheckedPlannedVisits', JSON.stringify(this.state.checkedVisits));
    }

    onClickApproveCheck = async () => {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        if (this.state.checkedVisits.length !== 0)
            await this.setState({ disableApprove: true });
        const updateVisitURL = constantURI() + "odooController/UpdateVisit";
        this.state.checkedVisits.map(async (item, index) => {
            if (item == true) {
                if (this.state.status[index] !== "3") {
                    var visitUpdateBody = {
                        jsonrpc: "2.0",
                        params: {
                            method: "write",
                            model: "calendar.event",
                            args: [[index], {
                                "x_status": "0",
                            }
                            ],
                            "kwargs": {}
                        },
                        "token": this.state.token
                    }
                    if (this.state.authenticate) {
                        await _post(updateVisitURL, visitUpdateBody).then((response) => {
                            return response.json().then(async (data) => {
                                if (data.result !== undefined) {
                                    await this.fetchVisits(this.state.selectedRep).then(() => {
                                        this.setState({ disableApprove: false })
                                    })
                                } else {
                                    this.setState({ alertUndefined: true });
                                }
                            })
                        })
                    }
                    else {
                        alert("Please connect to the Internet!");
                    }
                }
                else {
                    var visitUpdateBody = {
                        jsonrpc: "2.0",
                        params: {
                            method: "write",
                            model: "calendar.event",
                            args: [[index], {
                                "x_status": "2",
                            }
                            ],
                            "kwargs": {}
                        },
                        "token": this.state.token
                    }
                    if (this.state.authenticate) {
                        await _post(updateVisitURL, visitUpdateBody).then((response) => {
                            return response.json().then(async (data) => {
                                if (data.result !== undefined) {
                                    await this.fetchVisits(this.state.selectedRep).then(() => {
                                        this.setState({ disableApprove: false })
                                    })
                                } else {
                                    this.setState({ alertUndefined: true });
                                }
                            })
                        })
                    }
                    else {
                        alert("Please connect to the Internet!");
                    }
                }
            }
        })
    }

    closeDecline = () => {
        this.setState({ showDecline: false });
    }

    showDecline = () => {
        this.setState({ showDecline: true });
    }

    closeDeclineONE = (id) => {
        this.setState({ ...this.state.showDeclineONE[id] = false });
    }

    showDeclineONE = (id) => {
        this.setState({ ...this.state.showDeclineONE[id] = true });
    }

    onChangeReason = async (e) => {
        await this.setState({ reason: e.target.value });
    }

    onChangeReasonONE = async (e) => {
        await this.setState({ reasonOne: e.target.value });
    }

    onClickPressAll = (value) => {
        if (value.nativeEvent.target.checked) {
            this.setState({ selectAll: true });
            this.state.temp.map((item, index) => {
                this.setState({ ...this.state.checkedVisits[item.id] = true, ...this.state.status[item.id] = item.x_status });
            })
            Object.keys(this.state.visits).map((item, index) => {
                this.setState({ ...this.state.showDetail[index] = true });
            })
        }
        else {
            this.setState({ selectAll: false });
            this.state.temp.map((item, index) => {
                this.setState({ ...this.state.checkedVisits[item.id] = false });
            })
        }
    }

    onClickList = () => {
        this.setState({ isList: true });
        if (this.state.isSupervisor)
            this.fetchVisits(this.state.User);
        else
            this.fetchVisits(this.state.selectedRep);
    }

    onClickDaily = () => {
        this.setState({ isDaily: true, isWeekly: false });
    }

    onClickWeekly = () => {
        this.setState({ isDaily: false, isWeekly: true });
    }

    onClickMonthly = () => {
        this.setState({ isDaily: false, isWeekly: false });
    }

    render() {
        if (!this.state.loading) {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
                    <div className="row pt-3">
                        <div className="col">
                            <ArrowBackCircle className="btn" onClick={() => this.props.history.push("./LandingPageRep")} color={'#00bfff'} height="50px" width="50px" />
                        </div>
                        {(!this.state.alertUndefined) ?
                            null :
                            <div className="col alert alert-danger">
                                <div className="row">
                                    <h6 className="col-sm-8">There seems to be a problem.</h6>
                                    <div className="col d-flex flex-row-reverse">
                                        <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={() => window.location.reload()}>
                                            Reload</div>
                                    </div>
                                </div>
                            </div>
                        }
                        {(this.state.isRep) ?
                            (this.state.isList) ?
                                <div className="col mt-2 d-flex flex-row-reverse">
                                    <div className="btn" data-toggle="modal" data-target="#myModal" style={stylesMed.wideButton} onClick={this.showAlert}>Schedule Route</div>
                                </div> : null
                            : <div className="row mt-4">
                                <h3 className="col-sm-5 d-flex align-items-center">Select Representative:</h3>
                                <select className="col-sm-7 form-control" id="sel1" value={this.state.selectedRep}
                                    onChange={this.onChangeSelectedRep} name="sellist1" style={stylesMed.planInput}>
                                    <option value=""></option>
                                    {this.state.Reps.map((item, index) => {
                                        return (
                                            <option key={index} value={item.name}>{item.name}</option>
                                        )
                                    })}
                                </select>
                            </div>
                        }
                        <Modal show={this.state.showAlert} onHide={this.closeAlert} animation={false}>
                            <Modal.Header>
                                <Modal.Title>Select Routing Day</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div>
                                    {/*<div className="row mb-3">*/}
                                    {/*    <div className="col btn" data-toggle="modal" data-target="#myModal" style={(this.state.isDaily && !this.state.isWeekly) ? stylesMed.wideButtonFilter : null}*/}
                                    {/*        onClick={() => this.onClickDaily()}>Daily</div>*/}
                                    {/*    <div className="col btn" data-toggle="modal" data-target="#myModal" style={(!this.state.isDaily && this.state.isWeekly) ? stylesMed.wideButtonFilter : null}*/}
                                    {/*        onClick={() => this.onClickWeekly()}>Weekly</div>*/}
                                    {/*    <div className="col btn" data-toggle="modal" data-target="#myModal" style={(!this.state.isDaily && !this.state.isWeekly) ? stylesMed.wideButtonFilter : null}*/}
                                    {/*        onClick={() => this.onClickMonthly()}>Monthly</div>*/}
                                    {/*</div>*/}
                                    <DatePicker selected={this.state.Date} onChange={(date) => this.setState({ Date: date })} />
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <div className="btn" data-toggle="modal" data-target="#myModal" style={stylesMed.wideButton} onClick={this.onSave}>Save</div>
                                <div className="btn btn-secondary" data-toggle="modal" data-target="#myModal" style={stylesMed.cancelWideButton}
                                    onClick={this.closeAlert}>Cancel</div>
                            </Modal.Footer>
                        </Modal>
                    </div>
                    {/*<div class="btn-group">*/}
                    {/*    <div type="button" class="btn" onClick={() => this.onClickList()} style={{ backgroundColor: '#00bfff' }}>*/}
                    {/*        <ListOutline className="row align-items-center justify-content-center" color={'white'} height="50px" width="50px" />*/}
                    {/*    </div>*/}
                    {/*    <div type="button" class="btn" onClick={() => this.setState({ isList: false })} style={{ backgroundColor: '#00bfff' }}>*/}
                    {/*        <CalendarOutline className="row align-items-center justify-content-center" color={'white'} height="50px" width="50px" />*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {(this.state.isList) ?
                        <div className="pt-2">
                            {/*<div className="row mt-3">*/}
                            {/*    <div className="col btn h4 text-center"*/}
                            {/*        style={(this.state.isPlan) ? stylesMed.pressedTab : stylesMed.unpressedTab}*/}
                            {/*        onClick={() => this.onTabPress(true)}>Planned Visits</div>*/}
                            {/*    <div className="col btn h4 text-center"*/}
                            {/*        style={(!this.state.isPlan) ? stylesMed.pressedTab : stylesMed.unpressedTab}*/}
                            {/*        onClick={() => this.onTabPress(false)}>Previous Visits</div>*/}
                            {/*</div>*/}
                            {/*{(this.state.isRep) ? null :*/}
                            {/*    (!this.state.isPlan) ? null :*/}
                            {/*        <div className="row">*/}
                            {/*            <div className="m-2 col-sm-7" >*/}
                            {/*                <input type="checkbox" className="form-check-input" style={stylesMed.checkbox}*/}
                            {/*                    value={this.state.selectAll} onChange={(value) => this.onClickPressAll(value)} />Select All*/}
                            {/*        </div>*/}
                            {/*            <div className="m-2 col-sm-4" style={stylesMed.rightDirection} >*/}
                            {/*                <div className="row">*/}
                            {/*                    <div className="col-sm-6">*/}
                            {/*                        <div className="btn" style={stylesMed.wideButtonFilter} onClick={() => this.onClickApproveCheck()}>Approve</div>*/}
                            {/*                    </div>*/}
                            {/*                    <div className="col-sm-6">*/}
                            {/*                        <div className={(this.state.disableApprove) ? "btn disabled btn-danger" : "btn btn-danger"} onClick={() => this.showDecline()}>Decline</div>*/}
                            {/*                    </div>*/}
                            {/*                </div>*/}
                            {/*            </div>*/}
                            {/*        </div>*/}
                            {/*}*/}
                            {(this.state.isPlan) ?
                                <div>
                                    <div className="row mt-1">
                                        <div className="col">
                                            <p style={stylesMed.clientDetail}>From Date*: </p>
                                            <DatePicker selected={this.state.fromDatePlan} onChange={async (date) => { await this.setState({ fromDatePlan: date, toDatePlan: date }); this.fetchVisitsDate(); }} className="form-control" />
                                        </div>
                                        <div className="col">
                                            <p style={stylesMed.clientDetail}>To Date*: </p>
                                            <DatePicker selected={this.state.toDatePlan} onChange={async (date) => { await this.setState({ toDatePlan: date }); this.fetchVisitsDate(); }} className="form-control" />
                                        </div>
                                    </div>
                                    {Object.entries(this.state.visits).map((key, value) => {
                                        return (
                                            <div className="pt-3" style={stylesMed.mainBackgroundColor} key={value}>
                                                <div className="btn row bg-light" style={stylesMed.planTabs} onClick={() => this.onShowDetails(value)}>
                                                    <div className="row">
                                                        {(this.state.showDetail[value]) ?
                                                            <ArrowDownCircle className="col-2 pt-2 d-flex justify-content-start" color={'#00bfff'} height="35px" width="35px" />
                                                            :
                                                            <ArrowForwardCircle className="col-2 pt-2 d-flex justify-content-start" color={'#00bfff'} height="35px" width="35px" />
                                                        }
                                                        <p className="col pt-2 d-flex justify-content-start" style={stylesMed.planVisitDate}>{new Date(key[0]).toDateString()}</p>
                                                        <p className="col pt-2 d-flex justify-content-start " style={stylesMed.planVisitStatus}>Planned</p>
                                                    </div>
                                                </div>
                                                {(this.state.showDetail[value]) ?
                                                    key[1].map((item, index) => {
                                                        return (
                                                            <div className="row m-2" style={stylesMed.planItemDetail} key={index}>
                                                                {/*{(this.state.isRep) ? null :*/}
                                                                {/*    <div className="col-sm-1 m-2">*/}
                                                                {/*        <input type="checkbox" className="form-check-input" style={stylesMed.checkbox}*/}
                                                                {/*            checked={(this.state.checkedVisits[item.id] === undefined) ? false : this.state.checkedVisits[item.id]}*/}
                                                                {/*            value={(this.state.checkedVisits[item.id] === undefined) ? false : this.state.checkedVisits[item.id]}*/}
                                                                {/*            onChange={(newValue) => this.onCheck(newValue, item.id, item.x_status)} />*/}
                                                                {/*    </div>*/}
                                                                {/*}*/}
                                                                <div className="col-sm-4">
                                                                    <p style={stylesMed.planItemDetailName}>Visit #{index + 1}</p>
                                                                    <p>{item.name}</p>
                                                                </div>
                                                                <div className="col-sm-3 mt-5">
                                                                    <p style={(item.x_status === "4" || item.x_status === "3") ? stylesMed.planVisitPending : stylesMed.planVisitCompleted}>
                                                                        {(item.x_status === "4" || item.x_status === "3") ? "Waiting Approval" : "Pending"}</p>
                                                                </div>
                                                                {(this.state.isRep) ? null :
                                                                    <div className="col-sm-3 mt-5">
                                                                        {(item.x_status === "4") ?
                                                                            <div className="row">
                                                                                <div className="col-sm-6 invisible">
                                                                                    <div className={(this.state.disableApprove) ? "btn disabled btn-danger" : "btn btn-danger"} style={stylesMed.deleteButton} onClick={() => this.onApprove(item.id, item.x_status)}>Approve</div>
                                                                                </div>
                                                                                <div className="col-sm-6">
                                                                                    <div className="btn" style={stylesMed.wideButtonFilter} onClick={() => this.onApprove(item.id, item.x_status)}>Approve</div>
                                                                                </div>
                                                                            </div>
                                                                            : null}
                                                                        <Modal show={this.state.showDecline} onHide={this.closeDecline} animation={false}>
                                                                            <Modal.Header>
                                                                                <Modal.Title>Decline Reason: </Modal.Title>
                                                                            </Modal.Header>
                                                                            <Modal.Body>
                                                                                <div>
                                                                                    <div>
                                                                                        <textarea className="form-control m-2" value={this.state.reason} onChange={this.onChangeReason}
                                                                                            style={(this.state.showRequiredAlert && !this.state.requiredFields.objective) ?
                                                                                                stylesMed.reportClientInputRequired : stylesMed.reportClientInput} />
                                                                                    </div>
                                                                                    <div className="btn" style={stylesMed.deleteButtonAlert}
                                                                                        onClick={() => this.onDecline()}>Save</div>
                                                                                    <div className="btn btn-secondary" style={stylesMed.cancelButtonAlert}
                                                                                        onClick={() => this.closeDecline()}>Cancel</div>
                                                                                </div>
                                                                            </Modal.Body>
                                                                        </Modal>
                                                                        <Modal show={this.state.showDeclineONE[item.id]} animation={false}>
                                                                            <Modal.Header>
                                                                                <Modal.Title>Decline Reason: </Modal.Title>
                                                                            </Modal.Header>
                                                                            <Modal.Body>
                                                                                <div>
                                                                                    <div>
                                                                                        <textarea className="form-control m-2" value={this.state.reasonOne} onChange={this.onChangeReasonONE}
                                                                                            style={stylesMed.reportClientInput} />
                                                                                    </div>
                                                                                    <div className="btn" style={stylesMed.deleteButtonAlert}
                                                                                        onClick={() => this.onDeclineONE(item.id)}>Save</div>
                                                                                    <div className="btn btn-secondary" style={stylesMed.cancelButtonAlert}
                                                                                        onClick={() => this.closeDeclineONE(item.id)}>Cancel</div>
                                                                                </div>
                                                                            </Modal.Body>
                                                                        </Modal>
                                                                    </div>
                                                                }
                                                            </div>
                                                        )
                                                    })
                                                    : null
                                                }
                                            </div>
                                        )
                                    })
                                    }
                                </div> :
                                <div>
                                    <div className="row mt-1">
                                        <div className="col">
                                            <p style={stylesMed.clientDetail}>From Date*: </p>
                                            <DatePicker selected={this.state.fromDate} onChange={async (date) => { await this.setState({ fromDate: date, toDate: date }); this.fetchPreviousVisits(); }} className="form-control" />
                                        </div>
                                        <div className="col">
                                            <p style={stylesMed.clientDetail}>To Date*: </p>
                                            <DatePicker selected={this.state.toDate} onChange={async (date) => { await this.setState({ toDate: date }); this.fetchPreviousVisits(); }} className="form-control" />
                                        </div>
                                    </div>
                                    {Object.entries(this.state.previousVisits).map((key, value) => {
                                        return (
                                            <div className="pt-3" style={stylesMed.mainBackgroundColor} key={value}>
                                                <div className="btn row bg-light" style={stylesMed.planTabs} onClick={() => this.onShowDetails(value)}>
                                                    <div className="row">
                                                        {(this.state.showDetail[value]) ?
                                                            <ArrowDownCircle className="col-2 pt-2 d-flex justify-content-start" color={'#00bfff'} height="35px" width="35px" />
                                                            :
                                                            <ArrowForwardCircle className="col-2 pt-2 d-flex justify-content-start" color={'#00bfff'} height="35px" width="35px" />
                                                        }
                                                        <p className="col pt-2 d-flex justify-content-start" style={stylesMed.planVisitDate}>{new Date(key[0]).toDateString()}</p>
                                                    </div>
                                                </div>
                                                {(this.state.showDetail[value]) ?
                                                    key[1].map((item, index) => {
                                                        return (
                                                            <div className="row m-2" style={stylesMed.planItemDetail} key={index}>
                                                                <div className="col-sm-4">
                                                                    <p style={stylesMed.planItemDetailName}>Visit #{index + 1}</p>
                                                                    <p>{item.name}</p>
                                                                </div>
                                                                <div className="col-sm-4 mt-5">
                                                                    <p style={(item.x_status === "2") ? stylesMed.planVisitPending : ((item.x_status === "1") ? stylesMed.planVisitCompleted : stylesMed.planVisitCancelled)}>
                                                                        {(item.x_status === "2") ? "Cancelled" : ((item.x_status === "1") ? "Completed" : "Pending")}</p>
                                                                </div>
                                                                <div className="col-sm-4 mt-5">
                                                                    <p>Call Objective: {item.x_purpose}</p>
                                                                    <p>Special Request: {item.x_fbgeneral}</p>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                    : null
                                                }
                                            </div>
                                        )
                                    })
                                    }
                                </div>
                            }
                        </div> :
                        <Calendar className="mt-4" history={this.props.history}></Calendar>
                    }
                </div >
            );
        }
        else {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
                    <div className="col">
                        <ArrowBackCircle className="btn" onClick={() => this.props.history.push("./LandingPageRep")} color={'#00bfff'} height="50px" width="50px" />
                    </div>
                    {/*{(this.state.isRep) ?*/}
                    {/*    <div className="col mt-2 d-flex flex-row-reverse">*/}
                    {/*        <div className="btn" data-toggle="modal" data-target="#myModal" style={stylesMed.wideButton} onClick={this.showAlert}>Schedule Route</div>*/}
                    {/*    </div>*/}
                    {/*    : <div className="row mt-4">*/}
                    {/*        <h3 className="col-sm-5 d-flex align-items-center">Select Representative:</h3>*/}
                    {/*        <select className="col-sm-7 form-control" id="sel1" value={this.state.selectedRep}*/}
                    {/*            onChange={this.onChangeSelectedRep} name="sellist1" style={stylesMed.planInput}>*/}
                    {/*            <option value=""></option>*/}
                    {/*            {this.state.Reps.map((item, index) => {*/}
                    {/*                return (*/}
                    {/*                    <option key={index} value={item.name}>{item.name}</option>*/}
                    {/*                )*/}
                    {/*            })}*/}
                    {/*        </select>*/}
                    {/*    </div>*/}
                    {/*}*/}
                    <div className="pt-4 text-center">
                        <div className="spinner-border" style={stylesMed.spinner}></div>
                    </div>
                </div>
            )
        }
    }
}